// extracted by mini-css-extract-plugin
module.exports = {"root":"booking-progress-card_root__2TuMr"};